import React, { useEffect, useState } from 'react';
import { ptBR } from 'date-fns/locale';
import { addDays, getHours, isSameDay, startOfDay } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Loading from 'components/Loading';

const Calendario = (props) => {
  const ENDPOINT =
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
      : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
  const backgroundColor = props.backgroundColor;
  const [horariosEmpresa, setHorarioEmpresa] = useState([]);

  // CSS para estilo do calendário
  const css = `

        .rdp {
            background-color: #F3F3F3;
            padding: 10px;
            border-radius: 5px;
            --rdp-background-color: ${backgroundColor};
            --rdp-accent-color: #C2C6C5;
            color: black;
        }

        .rdp-caption {
            background-color: ${backgroundColor};
            border-radius: 5px;
        }

        .rdp-caption_label {
            color: #FFF
        }

        .rdp-nav_button  {
            rotate: 90deg;
        }

        .rdp svg {
            color: #FFF;
        }

        .rdp-day_selected {
            border-radius: 10px;
            color: black;
        }

    `;

  // Feriados mockados temporariamente. Devido ao UTC, tive que por 1 dia na frente.
  const currentYear = new Date().getFullYear();
  /*
    peguei esses feriados atualizados pq os anteriores estavam errados. 
    Alguns são facultativos, ent depende de quando a clinica vai funcionar.
  */
  const feriadosMock = [
    new Date(`${currentYear}-01-01`), // Ano Novo (1º de janeiro) – Feriado nacional
    new Date(`${currentYear}-04-21`), // Tiradentes (21 de abril) – Feriado nacional
    new Date(`${currentYear}-05-01`), // Dia do Trabalhador (1º de maio) – Feriado nacional
    new Date(`${currentYear}-09-07`), // Independência do Brasil (7 de setembro) – Feriado nacional
    new Date(`${currentYear}-10-12`), // Nossa Senhora Aparecida – Padroeira do Brasil (12 de outubro) – Feriado nacional
    new Date(`${currentYear}-11-02`), // Finados (2 de novembro) – Feriado nacional
    new Date(`${currentYear}-11-15`), // Proclamação da República (15 de novembro) – Feriado nacional
    new Date(`${currentYear}-11-20`), // Dia da Consciência Negra (20 de novembro) – Feriado nacional em alguns estados
    new Date(`${currentYear}-12-25`), // Natal (25 de dezembro) – Feriado nacional
  ];

  // Datas disponíveis
  const datasDisponiveis = props.datasDisponiveis || [];

  const isFeriado = (date) => {
    const dataFormatada = date.toISOString().split('T')[0];

    return feriadosMock.some((feriado) => {
      const feriadoFormatado = feriado.toISOString().split('T')[0];

      return dataFormatada === feriadoFormatado;
    });
  };

  const estaDataDisponivel = (date) => {
    const hoje = startOfDay(new Date());
    const horaAtual = new Date().getHours() * 60 + new Date().getMinutes();
    let horaInicio, horaFim;

    switch (date.getDay()) {
      case 0: // Domingo
        horaInicio = horariosEmpresa?.horario_integral_dom_inicio;
        horaFim = horariosEmpresa?.horario_integral_dom_fim;
        break;
      case 6: // Sábado
        horaInicio = horariosEmpresa?.horario_integral_sab_inicio;
        horaFim = horariosEmpresa?.horario_integral_sab_fim;
        break;
      default: // Dias da semana (segunda a sexta)
        horaInicio = horariosEmpresa?.horario_integral_seg_sex_inicio;
        horaFim = horariosEmpresa?.horario_integral_seg_sex_fim;
        break;
    }

    if (horaInicio !== null && horaFim !== null && horaInicio !== undefined && horaFim !== undefined) {
      const [horaInicioHour, horaInicioMin] = horaInicio.split(':').map(Number);
      const [horaFimHour, horaFimMin] = horaFim.split(':').map(Number);

      const horaInicioTotalMin = horaInicioHour * 60 + horaInicioMin;
      const horaFimTotalMin = horaFimHour * 60 + horaFimMin;

      if (date.getDate() === hoje.getDate() && horaAtual >= horaFimTotalMin) {
        // Se o horário de funcionamento já passou hoje, então o dia não está disponível
        return false;
      }
    }

    if (!datasDisponiveis || datasDisponiveis.length === 0) {
      return date >= hoje;
    }

    return datasDisponiveis.some((disponivel) => isSameDay(disponivel, date)) && date >= hoje && !isFeriado(date);
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: css }} />
      <DayPicker
        defaultMonth={props.date}
        mode="single"
        selected={props.date}
        locale={ptBR}
        onDayClick={(day) => {
          if (estaDataDisponivel(day)) {
            const date = new Date(day.toISOString().split('T')[0] + 'T12:00:00');
            props.setDate(date);
            if (day.getDay() === 6) {
              console.log('dia clicado sabado');
              props.setIsSaturday(true);
            } else {
              props.setIsSaturday(false);
            }
          }
        }}
        disabled={(day) => !estaDataDisponivel(day) || day.getDay() === 0 || isFeriado(day)}
      />
    </>
  );
};

export default Calendario;
